import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Typography, Button, LinearProgress } from '@mui/material';
import axios from 'axios';
import { newServer } from '../../constants/constants';
// Definición de tipos
interface FilterOption {
  id: number;
  value: string;
  label: string;
  is_default: boolean;
}

interface FilterCategory {
  id: number;
  name: string;
  field_name: string;
  display_order: number;
  options: FilterOption[];
}

interface ActiveFiltersType {
  [key: string]: string;
}

const url = `${newServer}`;
interface DynamicFiltersProps {
  onFilterChange: (filters: ActiveFiltersType) => void;
  apiUrl: string; // URL base para las peticiones
}

interface Experience {
  id: number;
  display_text: string;
  range: string;
}
interface PriceRange {
  id: number;
  display_text: string;
  range: string;
}
interface Rating {
  id: number;
  display_text: string;
}

const DynamicFilters: React.FC<DynamicFiltersProps> = ({ onFilterChange, apiUrl = url }) => {
  const [filters, setFilters] = useState<FilterCategory[]>([]);
  const [activeFilters, setActiveFilters] = useState<ActiveFiltersType>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [skills, setSkills] = useState<FilterOption[]>([]);
    const [languages, setLanguages] = useState<FilterOption[]>([]);
 const [showFilters, setShowFilters] = useState(true);
  const [viewRating, setViewRating] = useState(false);
  const [experiences, setExperiences] = useState<Experience[]>([]);
    const [priceRanges, setPriceRanges] = useState<PriceRange[]>([]);
    const [ratings, setRatings] = useState<Rating[]>([]);
    
  // Cargar los filtros desde la API
  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const response = await axios.get(`${apiUrl}directory`);
        const data = response.data as { skills: any[]; lenguages: any[]; dynamicFilters: FilterCategory[]; viewRating: boolean;filter:any[] };
        const responseFilters = await fetch(`${newServer}/filters`);
        const dataFilters = await responseFilters.json();
        setExperiences(dataFilters.experiences);
        setPriceRanges(dataFilters.priceRanges);
        setRatings(dataFilters.ratings);
        // Convertimos skills y lenguajes a la estructura esperada de FilterOption
        const skillsData = data.skills.map((skill: any) => ({
          id: skill.id,
          value: skill.nombre.toLowerCase(),
          label: skill.nombre,
          is_default: false,
        }));
  
        const languagesData = data.lenguages.map((language: any) => ({
          id: language.id,
          value: language.nombre.toLowerCase(),
          label: language.nombre,
          is_default: false,
        }));
        console.log("-----",data.filter[0]);
        setViewRating(data.filter[0].setting_enable_rating);
        console.log("-----",data.filter[0].setting_enable_rating);

        setSkills(skillsData);
        setLanguages(languagesData);
        setFilters(data.dynamicFilters || []);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching metadata:', err);
      }
    };
  
    fetchMetadata();
  }, [apiUrl]);

  // Manejar cambios en los filtros
  const handleFilterChange = (fieldName: string, value: string) => {
    const updatedFilters = {
      ...activeFilters,
      [fieldName]: value,
      page: '1', // Reset page to 1
      limit: '5' // Reset limit to 5
    };
    
    setActiveFilters(updatedFilters);
    
    // Notificar al componente padre sobre el cambio
    if (onFilterChange) {
      onFilterChange(updatedFilters);
    }
  };
  const clearFilters = () => {
    setActiveFilters({});
    onFilterChange({});
  }

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <div className='bg-white shadow-xl rounded-lg mb-10 p-2  sticky top-0 z-10'>
      <div className='flex justify-between items-center mb-4'>
        <Typography variant='h6' className='text-gray-800 font-semibold'>
          Filters
        </Typography>
        <div className='flex gap-2'>
          <Button variant='outlined' size='small' onClick={clearFilters} className='text-gray-600'>
            Clear All
          </Button>
          <Button
            variant='text'
            size='small'
            onClick={() => setShowFilters(!showFilters)}
            className='text-gray-600'
          >
            {showFilters ? 'Hide' : 'Show'} Filters
          </Button>
        </div>
      </div>

      {showFilters && (
        <div
          className={`grid ${
            viewRating ? 'grid-cols-5' : 'grid-cols-4'
          } sm:grid-cols-1 md:grid-cols-3 ${
            viewRating ? 'lg:grid-cols-5' : 'lg:grid-cols-4'
          } gap-4`}
        >
    
        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
  <InputLabel>Practice Area</InputLabel>
  <Select
    value={activeFilters.practiceArea || ''}
    label="Practice Area"
    onChange={(e: SelectChangeEvent) => handleFilterChange('practiceArea', e.target.value)}
  >
    <MenuItem value="">All Practice Areas</MenuItem>
    {skills.map((skill) => (
      <MenuItem key={skill.id} value={skill.value}>
        {skill.label}
      </MenuItem>
    ))}
  </Select>
</FormControl>

<FormControl fullWidth size="small" sx={{ mb: 2 }}>
  <InputLabel>Language</InputLabel>
  <Select
    value={activeFilters.language || ''}
    label="Language"
    onChange={(e: SelectChangeEvent) => handleFilterChange('language', e.target.value)}
  >
    <MenuItem value="">All Languages</MenuItem>
    {languages.map((language) => (
      <MenuItem key={language.id} value={language.value}>
        {language.label}
      </MenuItem>
    ))}
  </Select>
</FormControl>
<FormControl fullWidth size="small" sx={{ mb: 2 }}>
  <InputLabel>Experience</InputLabel>
  <Select
    value={activeFilters.experience || ''}
    label="Experience"
    onChange={(e: SelectChangeEvent) => handleFilterChange('experience', e.target.value)}
  >
    <MenuItem value="">Any Experience</MenuItem>
    {experiences.map((language) => (
      <MenuItem key={language.id} value={language.range}>
        {language.display_text}
      </MenuItem>
    ))}
  </Select>
</FormControl>
<FormControl fullWidth size="small" sx={{ mb: 2 }}>
  <InputLabel>Price Range</InputLabel>
  <Select
    value={activeFilters.priceRange || ''}
    label="Price Range"
    onChange={(e: SelectChangeEvent) => handleFilterChange('priceRange', e.target.value)}
  >
    <MenuItem value="">All price</MenuItem>
    {priceRanges.map((language) => (
      <MenuItem key={language.id} value={language.range}>
        {language.display_text}
      </MenuItem>
    ))}
  </Select>
</FormControl>
{viewRating && (
  <FormControl fullWidth size="small" sx={{ mb: 2 }}>
    <InputLabel>Rating</InputLabel>
    <Select
      value={activeFilters.rating || ''}
      label="Rating"
      onChange={(e: SelectChangeEvent) => handleFilterChange('rating', e.target.value)}
    >
      <MenuItem value="">Any Rating</MenuItem>
      {ratings.map((language) => (
        <MenuItem key={language.id} value={language.display_text}>
          {language.display_text}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)}
     
    </div>
      )}
    </div>
  );
};

export default DynamicFilters;